<template>
  <div class="position-relative mt-3" id="valuemappingTable">

    <div class="actions text-right" id="valuemappingTable-showAddEditDialog">
      <button class="btn btn-primary icon-button" @click="showAddEditDialog = true" id="valuemappingTable-add-Button">
        <span class="btn-icon" id="valuemappingTable-addButton-span"><i class="fa fa-plus" aria-hidden="true"
            id="valuemappingTable-addButton-data"></i></span>
        {{ 'ADD' | translate }}
      </button>
    </div>

    <vodal :show="showAddEditDialog" :width="400" :closeOnEsc="true" :closeOnClickMask="false"
      :customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto'}" animation="rotate" @hide="closeDialog">
      <valuemapping-add-edit-dialog :edited="editedRow" @save="onSaveNew" @update="onUpdate" @close="closeDialog" :errortype="error"
        id="valuemappingTable-addEditDialog"></valuemapping-add-edit-dialog>
    </vodal>
    <table class="table table-striped table-hover" id="valuemappingTable-tableData">
      <caption></caption>
      <tr>
        <th>Product</th>
        <th>AFD field</th>
        <th>AFD value</th>
        <th>{{ 'API_VALUE_INCOMING' | translate }}</th>
        <th>{{ 'API_VALUE_OUTGOING' | translate }}</th>
      </tr>
      <template v-for="row in rows">
        <tr>
          <td>{{ row.product }}</td>
          <td>{{ row.afdField }}</td>
          <td>{{ row.afdValue }}</td>
          <td>
            <div v-for="(apiValueIncoming, index) in row.apiValueIncoming" :key="index" class="apiValueIncoming-item">
              {{ apiValueIncoming }}
            </div>
          </td>
          <td>{{ row.apiValueOutgoing }}</td>
          <td id="valuemappingTable-tableButtons">
            <button class="btn btn-success icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('EDIT')" @click="onEdit(row)"
              :id="'valuemappingTable-tableEditButton-'+row.product">
              <span class="btn-icon" :id="'valuemappingTable-tableEditSpan-'+row.product"><i class="fa fa-pencil"
                  aria-hidden="true" :id="'valuemappingTable-tableEditData-'+row.product"></i></span>
            </button>
            <button class="btn btn-danger icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('DELETE')" @click="confirmDelete(row)"
              :id="'valuemappingTable-tableDeleteButton'+row.product">
              <span class="btn-icon" :id="'valuemappingTable-tableDeleteSpan-'+row.product"><i class="fa fa-trash-o"
                  aria-hidden="true" :id="'valuemappingTable-tableDeleteData-'+row.product"></i></span>
            </button>
          </td>
        </tr>
      </template>
    </table>
    <confirm-dialog :show="showDeleteConfirmDialog" :textLabel="'Are you sure you want to delete this?'"
              @hide-dialog="showDeleteConfirmDialog = false" @confirm="onRemove(selectedRow.id)">
            </confirm-dialog>
  </div>
</template>
    
    <script>
    import RestService from '../../../service/RestService.js';
    import valuemappingAddEditDialog from './ValueMappingAddEditDialog';
    import Datepicker from 'vuejs-datepicker';
    import Vodal from 'vodal';
    import GeneralConfigService from '../../../service/GeneralConfigService';
    import ConfirmDialog from '../../dialog/ConfirmDialog.vue';
    
    export default {
      components: { valuemappingAddEditDialog, Datepicker, Vodal, ConfirmDialog },
      data() {
        return {
          rest: this.initRestService(),
          filter: '',
          rows: [],
          newRows: [],
          editedRow: null,
          showAddEditDialog: false,
          showDeleteConfirmDialog: false,
          selectedRow: null,
          error: null
        }
      },
      beforeMount() {
        this.loadRows();
      },
      methods: {
        initRestService() {
          return new RestService();
        },
        async loadRows() {
          const valuemappingResponse = await this.rest.getAllValuemappingRows();
          this.rows = valuemappingResponse.data;
        },
        async onSaveNew(row) {
          try {
            await this.rest.createValuemappingRow(row);
            this.closeDialog();
            this.loadRows();
          } catch (error) {
            if (error.response && error.response.status === 409) {
              this.setError('ERROR_DUPLICATE_RECORD');
            } else {
              this.setError('ERROR_DURING_OPERATION');
            }
            this.$log.error(error.response ? error.response.data : error);
          }
        },
        async onUpdate(row) {
          try {
            await this.rest.updateValuemappingRow(row);
            this.closeDialog();
            this.loadRows();
          } catch (error) {
            if (error.response && error.response.status === 409) {
              this.setError('ERROR_DUPLICATE_RECORD');
            } else {
              this.setError('ERROR_DURING_OPERATION');
            }
            this.$log.error(error.response ? error.response.data : error);
          }
        },
        onEdit(row) {
          this.editedRow = { ...row };
          this.showAddEditDialog = true;
        },
        onRemove(rowId) {
          const deletedRow = this.rows.find(row => { return row.id === rowId });
          this.rows = this.rows.filter(row => row.id !== rowId);
          this.rest.deleteValuemappingRow(rowId);
          GeneralConfigService.removeEnabledValueMapping(deletedRow)
          this.showDeleteConfirmDialog = false;
        },
        closeDialog() {
          this.showAddEditDialog = false;
          this.editedRow = false;
        },
        confirmDelete(row) {
          this.selectedRow = row;
          this.showDeleteConfirmDialog = true;
        },
        setError(errorMessage) {
          this.error = errorMessage;
          setTimeout(() => {
            this.error = false;
          }, 5000);
        }
      }
    }
    </script>
    
    <style lang="scss" scoped>
      >>> .vue-table {
        border: 0;
    
        th, td {
          border-right: 0;
          border-bottom: 0;
          border-left: 0;
        }
    
        thead > tr > th {
          padding-right: .75rem;
          padding-left: 30px !important;
        }
    
        .arrow:before {
          bottom: 12px;
          right: auto;
          left: 12px;
          font-family: 'FontAwesome', sans-serif;
        }
    
        .icon-button {
          opacity: 0;
          transition: opacity .1s ease-out;
        }
    
        tr:hover .icon-button {
          opacity: 1;
        }
      }
    
      .actions {
        position: absolute;
        z-index: 1;
        top: 10px;
        right: 0;
    
        .icon-button {
          padding-right: 15px;
          padding-left: 50px;
        }
      }
    </style>
    


// WEBPACK FOOTER //
// src/components/admin/valuemapping/ValueMappingTable.vue